import { Component, OnInit } from '@angular/core';
import { Session } from 'src/app/models/session';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmService } from '../confirm/confirm.service';
import { AsignarTecnicoService } from '../asignar-tecnico/asignar-tecnico.service';
import { DatePipe } from '@angular/common';
import { AsignarFechaService } from '../asignar-fecha/asignar-fecha.service';
import { AgregarRepuestoDialogServie } from '../agregar-repuesto-dialog/agregar-repuesto-dialog.service';
import { AdminTicketReviewDialogService } from '../admin-ticket-review-dialog/admin-ticket-review-dialog.service';
import { CodeNode } from 'source-list-map';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.css']
})
export class TicketComponent implements OnInit {

  constructor(private session:Session, private activatedRoute: ActivatedRoute, private router: Router, private service: UserService, 
    private toast: ToastrService,private reviewService: AdminTicketReviewDialogService, private confirm: ConfirmService, private asignarTecnicoService: AsignarTecnicoService, private asignarFechaService: AsignarFechaService, private agregarRepuestoService: AgregarRepuestoDialogServie) { }

  ticket_id = "";
  ticket;
  tecnico_a_reasignar;
  comentario = "";
  motivo_cancelacion = "";
  cancel_clicked = false;
  comentarios_limit = 5;

  productos = [];

  editTelefono;

  ngOnInit() {
    this.service.getTecnicos().subscribe(d=>{
      this.session.tecnicos = d;
      this.activatedRoute.params.subscribe(d=>{
        this.ticket_id = d.id;
        this.getTicketData();
      })
    }, err=>{
      this.toast.error("Error obteniendo tecnicos");
    })
  }


  saveTelefonoActualiado(){
    if(!(/^[0-9]+$/.test(this.editTelefono))){
      return this.toast.error("Teléfono inválido");
    }
    this.service.putTelefono(this.ticket_id, this.editTelefono).subscribe(d=>{
      this.ticket.telefono = this.editTelefono;
      this.editTelefono = null;
    }, er=>{
      return this.toast.error("Error");
    })
    
  }

  getTicketData(){
    this.service.getTicket(this.ticket_id).subscribe(t=>{
      this.ticket = t.ticket;
      this.ticket.comentarios.sort( (a,b) => { return -1 });
      this.ticket.repuestos_solicitados.forEach( (element: any) => {
        
        let found = t.solicitudes.find(x=> x._id == element.id);
        if(found){
          element.repuestos = found.repuestos_solicitados;
          element.fecha_alta = found.fecha_alta;
          element.fecha_recibido = found.fecha_recibido;
          switch(found.status){
            case "PENDIENTE": found.status = 2;break;
            case "EN CAMINO": found.status = 3;break;
            case "RECIBIDO": found.status = 4;break;
            case "CANCELADO": found.status = 5;break;
          }
          element.status = found.status;
        } 
      });
    }, er=>{
      this.toast.error(er.error);
    })
  }
  

  reasignar(){
    if(!this.tecnico_a_reasignar || !this.tecnico_a_reasignar._id) return;
    let enviar_whatsapp = confirm("¿Enviar Whatsapp al cliente informando el nuevo técnico asignado? ( " + this.ticket.telefono + ")");
    this.service.reasignarTicket(this.ticket, this.tecnico_a_reasignar,enviar_whatsapp).subscribe(d=>{
      this.getTicketData();
    },er=>{
      this.toast.error(er.error);
    })
  }

  agregarComentario(){
    if(this.comentario.length<1) return;
    this.service.postTicketComentario(this.ticket, this.comentario).subscribe(d=>{
      this.ticket.comentarios.push(d);
      this.ticket.comentarios.sort( (a,b) => { return (new Date(b.fecha).getTime())-(new Date(a.fecha).getTime()) });
      this.comentario = "";
    }, er=> { this.toast.error(er.error )});
  }

  cancelar(){
    this.confirm.confirm('Cancelar solicitud', 'Está seguro que desea cancelar la solicitud?', "SI", "NO")
    .then((confirmed) => { 
      if(confirmed){
        this.service.cancelTicket(this.ticket._id).subscribe(d=>{
          this.toast.success("TICKET CANCELADO")
          this.ticket.status = "CANCELADO";
        }, er=>{
          this.toast.error("ERROR");
        })
      }
    });
  }

  enEspera(){
    this.confirm.confirm('Estado de solicitud', 'Está seguro que desea poner la solicitud en espera?', "SI", "NO")
    .then((confirmed) => { 
      if(confirmed){
        this.service.enEsperaTicket(this.ticket._id).subscribe(d=>{
          this.toast.success("TICKET PUESTO EN ESPERA")
          this.ticket.status = "EN ESPERA";
        }, er=>{
          
          this.toast.error("ERROR");
        })
      }
    });
  }

  asignar(){
    let pipe = new DatePipe('en-US');
    let msg =  "Seleccione el técnico a asignar\n" + this.getDomicilioFinal() + "\n" + "Próxima visita: " + pipe.transform(new Date(this.getUltimaVisita().fecha), "dd/MM/yyyy") ;
    this.asignarTecnicoService.asignar(this.ticket,"Asignar Tecncico",msg, "Asignar", "Cancelar").then( (tecnico) => {
      let enviar_whatsapp = confirm("¿Enviar Whatsapp al cliente informando el nuevo técnico asignado? ( " + this.ticket.telefono + ")");
      this.service.reasignarTicket(this.ticket, tecnico, enviar_whatsapp).subscribe(d=>{
        this.getTicketData();
      },er=>{
        this.toast.error(er.error);
      });
    });
  }

  getDiferenciaDias(){
    let a = new Date(this.ticket.fecha_alta).getTime();
    let b = new Date().getTime();
    let isOpen = true;
    if(this.ticket.fecha_finalizado){
      b = new Date(this.ticket.fecha_finalizado).getTime();
      isOpen = false;
      console.log(a + "\n"  + b);
      
    } 
    return Math.round((b-a)/(1000*60*60*24)) + (isOpen?"+":"");
  }

  getDomicilioFinal(){
    return this.ticket.domicilio + ', ' + this.ticket.zona.localidad + ', ' + this.ticket.zona.provincia;
  }

  getUltimaVisita(){
    return this.ticket.visitas[this.ticket.visitas.length-1];
  }

  
  getDiferenciaDiasRepuestos(){
    let days = 0;
    let isOpenAll = false;
    console.log(this.ticket.repuestos_solicitados);
    
    this.ticket.repuestos_solicitados.forEach( x=>{
      if(!x.fecha_recibido){
        isOpenAll = true;
        return;
      } 
      let a = new Date(x.fecha_alta).getTime();
      let b = new Date(x.fecha_recibido).getTime();
      days+=Math.round((b-a)/(1000*60*60*24));
      console.log(">>>" + days);
      
    });
    return days + (isOpenAll?"+":"");
  }

  reagendarVisista(){
    this.asignarFechaService.asignar("Reagendar visita", "Indique la fecha para la nueva visita").then( fecha => {
      this.service.reagendarTicket(this.ticket._id, fecha).subscribe(d=>{
        this.getTicketData();
      }, er=>{
        this.toast.error("Error");
      });
    })
  }

  setEnCamino(solicitud){
    this.confirm.confirm("Confirmar envío", "El envío pasara a estado EN CAMINO", "ACEPTAR", "Cancelar").then(confimed =>{
      if(!confimed) return;
      solicitud._id = solicitud.id;
      this.service.setEnCamino(solicitud).subscribe(d=>{
        solicitud.status = 3;
        this.toast.success("Pedido en Camino", "Se informó que el pedido va en camino");
      }, er =>{
        this.toast.error("Error");
      })

    })
   
  }


  agregarRepuesto(solicitud){
    console.log(solicitud);
    
    this.agregarRepuestoService.agregar(solicitud.repuestos,"Agregar repuesto", "Agregar repuestos", "OK", "CANCELAR", 'lg').then( nuevos =>{
      console.log(nuevos);
      this.service.agregarRepuestosASolicitud(solicitud.id, nuevos).subscribe(d=>{
        this.getTicketData();
        
      }, er=>{
        console.log(er);
        this.toast.error("ERROR");
        
      })
      
    });
  }

  cancelarPedidoRepuestos(solicitud){
    this.confirm.confirm("Cancelar solicitud", "¿Está seguro que desea cancelar la solicitud de repuestos?", "Aceptar", "Cancelar").then(confirmed =>{
      if(!confirmed) return;
      this.service.cancelarSolicitudRepuestos(solicitud.id).subscribe(d=>{
        this.toast.success("Solicitud cancelada");
      }, er=>{
        this.toast.error("ERROR");
      })
    })
  }


  calificar(){
    this.reviewService.calificar("Calificar al tecnico en base a gestión del ticket", "Califica al tecnico en base al ticket finalizado : " + this.ticket._id, "Calificar", "Cancelar").then(values =>{
      if(values.puntos!=0 && values.comentario.length>0){
        this.service.adminTicketReview(this.ticket._id, values.comentario, values.puntos + 3).subscribe(d=>{
          this.toast.success("Calificacion enviada con éxito");
        }, er=>{
          this.toast.error("ERROR");
        })
      }
    })
  }

  validarGarantia(){
    this.confirm.confirm("Confirmar garantía" , "¿Confirma la vigencia de la garantìa?", "Confirmar", "Cancelar").then( confirmed =>{
      if(!confirmed) return;
      this.service.validarGarantia(this.ticket._id).subscribe(d=>{
        this.ticket.admin_confirma_garantia = true;
      })
    })
  }



  showModProducto = false;
  modProducto(){
    if(this.showModProducto){
      this.showModProducto = false;
      return;
    }
    this.showModProducto = true;
    if(this.productos.length==0){
      this.getProductos();
    }

  }

  getProductos(){
    this.service.getProductos().subscribe(d=>{
      this.productos = d.productos;
      this.productos.sort( (a,b) => { return a.barcode > b.barcode? 1:-1 });
      this.modProducto();
    })
  }

  productoSeleccionado;
  actualizarProducto(){
    this.service.updateProductoDelTicket(this.ticket._id, this.productoSeleccionado).subscribe( d=>{
      this.ticket.producto = this.productoSeleccionado;
      this.showModProducto = false;
    }, er=>{
      this.toast.error(er.error, "Error");
    })
  }

  showEditarGarantia = false;
  nuevaGarantia = "";
  editarGarantia(){
    console.log('editarn garantia');
    
    if(this.showEditarGarantia) return this.showEditarGarantia = false ;
    this.showEditarGarantia = true;
    this.nuevaGarantia = this.ticket.garantia;
  }

  saveGarantiaNueva(){
    this.service.updateGarantiaDelTicket(this.ticket._id, this.nuevaGarantia).subscribe(d=>{
      this.ticket.garantia = this.nuevaGarantia;
      this.showEditarGarantia = false;
    }, er=>{
      this.toast.error(er.error, "Error");
    })
  }



  eliminar_costo_asociado(id){
    if(confirm("Esta seguro de eliminar el costo asociado?")){
      this.service.eliminarCostoAsociadoATicket(this.ticket_id,id).subscribe(d=>{
        this.ticket.costos_asociados = d;
        this.toast.success("Costo asociado eliminado");
      }, er=>{
        this.toast.error(er.error);
      });
    }
  }


  nuevoCostoAsociado = { item: "", value: ""};
  agregarCostoAsociado(){
    let valorFinal = parseFloat(this.nuevoCostoAsociado.value);
    if(isNaN(valorFinal)) return this.toast.error("Valor inválido");

    this.service.agregarCostoAsociadoATicket(this.ticket_id, this.nuevoCostoAsociado.item, valorFinal).subscribe(d=>{
      this.ticket.costos_asociados = d;
        this.toast.success("Se agregó costo asociado");
        this.nuevoCostoAsociado = { item: "", value: ""};
      }, er=>{
        this.toast.error(er.error);
      });
  }

  getTotalCostosAsociados(){
    let ret = 0;
    this.ticket.costos_asociados.forEach(element => {
      ret+=element.value;
    });
    return ret;
  }



  generarSolicitudReuestosUtilizados(){
    this.service.generarPedidoDeRepuestosPorUtilizadosEnElTicket(this.ticket_id).subscribe(d=>{
      this.toast.success("SE HA GENERADO LA ORDEN");
      this.ticket.solicitud_repuestos_utilizados_enviada = true;
      this.ticket.solicitud_repuestos_utilizados_id = d.result;
    }, er=>{
      this.toast.error("ERROR");
    })
  }


  finalizar(){
    let confirmar = confirm("Confirma que desea finalizar el ticket?");
    if(!confirmar) return;

    let data = {
      repuestos: [],
      code: this.ticket.code,
      uso_garantia: false,
      fallas: [],
      factura: {},
      kms_recorridos: 0,
      ns: ""
    }

    this.service.finalizarTicket(this.ticket_id, data).subscribe(d=>{
      this.getTicketData();
    })
  }

  toggleWhatsapp(event){
    console.log(event);
    if(confirm( (event?"Activar whatsapp?":"Desactivar whatsapp"))){
      this.service.toggle_ticket_whatsapp(this.ticket_id,event).subscribe(d=>{

      })
    }
  }

  retry48(){
    if(confirm("Meter en cola de 48 hs?")){
      this.service.retry48(this.ticket_id).subscribe(d=>{
        this.getTicketData();
      });
    }
  }
}
